import { Suspense, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { FieldWorkerGuideFab } from './FieldWorkerGuideFab';

function FieldWorkerNavSuspenseFallback() {
  return (
    <div
      className="min-h-[100dvh] flex flex-col items-center justify-center gap-3 bg-gradient-to-br from-slate-50 via-gray-50 to-slate-50 px-6"
      aria-busy="true"
      aria-label="טוען מסך"
    >
      <Loader2 className="h-9 w-9 animate-spin text-slate-500" strokeWidth={2.25} aria-hidden />
      <p className="text-sm font-semibold text-slate-600 text-center">טוען מסך...</p>
    </div>
  );
}

/**
 * Wraps all field-worker routes: page enter animation + localized Suspense for lazy pages.
 */
export function FieldWorkerAnimatedLayout() {
  const location = useLocation();
  const showGuideFab = location.pathname !== '/field-worker/guides';

  useEffect(() => {
    document.getElementById('root')?.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="overflow-x-hidden max-w-[100vw]">
      <Suspense fallback={<FieldWorkerNavSuspenseFallback />}>
        <div
          key={location.pathname}
          className="min-h-[100dvh] motion-reduce:animate-none animate-fw-page-enter"
        >
          <Outlet />
        </div>
      </Suspense>
      {showGuideFab && <FieldWorkerGuideFab />}
    </div>
  );
}
